import { render, staticRenderFns } from "./FindCompanies.vue?vue&type=template&id=635e08c1&scoped=true&"
import script from "./FindCompanies.vue?vue&type=script&lang=ts&"
export * from "./FindCompanies.vue?vue&type=script&lang=ts&"
import style0 from "./FindCompanies.vue?vue&type=style&index=0&id=635e08c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635e08c1",
  null
  
)

export default component.exports